import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_CLIENT_INFO } from "../../config/connString";
import useAxios from "../../utils/useAxios";

const getAllClient = createAsyncThunk(
  "clients/get-all-clients",
  async (data) => {
    try {
      const api = useAxios();
      const config = {
        params: {
          search: data.search,
          pageSize: data.pageSize,
          pageNumber: data.pageNumber,
          sortField: data.sortField,
          sortDirection: data.sortDirection,
        },
      };
      const response = await api.get(URL_CLIENT_INFO, config);
      return response.data;
    } catch (error) {
      return Promise.reject(error.response);
    }
  }
);

export { getAllClient };
